<template>
  <div>
    <div class="modal show fade modal text-left " style="display: block;" v-if="show">
      <div class="modal-dialog modal-sm modal-dialog-centered ">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              {{ forUpdate ? "Update" : "Create"}} Department
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="validate-form mt-2">
              <div class="row">
                <div class="col-12 ">
                  <div class="form-group">
                    <label for="account-name">Department Name</label>
                    <input
                        type="text"
                        v-model="name"
                        id="dep-create"
                        class="form-control"
                        :class="
                                  errorBag.has('name') ? 'is-invalid' : ''
                                "
                        name="name"
                        placeholder="Name"
                        v-validate="'required'"
                    />
                    <small
                        v-show="errorBag.has('name')"
                        class="invalid-feedback"
                    >{{ "*" + errorBag.first("name") }}</small
                    >
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer justify-content-center">
            <button
                type="button"
                class="btn btn-primary mr-1 d-flex"
                @click="sendCall"
                :disabled="loading"
            >
              <Loader :loading="loading" :size="size"></Loader>
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: ['show', 'data', 'forUpdate'],
  data() {
    return {
      size: "10px",
      name:'',
      loading: false,
      url:"v1/cms-create-department"
    };
  },
  methods: {
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let data = {
            name : this.name,
          }
          let url = this.url
          if(this.forUpdate){
            data.id = this.data.id
            data.status = this.data.status
            url = 'v1/cms-update-department'
          }

          this.makeRequest("post", url, data).then(callResponse => {
            this.loading = false;
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                if(this.forUpdate){
                  let rawdata = this.$store.getters.getTableData(this.data.storageKey+'_custom')
                  let rowProp = this.data
                  rowProp.name = this.name
                  rawdata[this.data.idx] = rowProp
                  this.$store.dispatch('setTableData', { key: this.data.storageKey+'_custom', data: {...rawdata} })
                }
                this.$emit('completed')
              }
            }
          });
        }
      });
    }
  },
  watch: {
    show() {
      this.$nextTick(() => {
        this.name = ''
        if(this.forUpdate){
          this.name = this.data.name
        }
      });
    },
  }
};
</script>

<style scoped>
.modal {
  display: block !important;
  /* I added this to see the modal, you don't need this */
}

/* Important part */
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  //height: 70vh;
  overflow-y: auto;
}
</style>
